let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Z9IW")).then(() => parcelRequire('dSNlq'));